// Website Components
export { default as Header } from './Header';
export { default as Footer } from './Footer';
export { default as LandingPage } from './LandingPage';
export { default as PricingPage } from './PricingPage';
export { default as PricingNew } from './PricingNew';
export { default as FAQsPage } from './FAQsPage';
export { default as TermsPage } from './TermsPage';
export { default as PrivacyPage } from './PrivacyPage';
export { default as ContactUsPage } from './ContactUsPage';
export { default as AppDownloadPage } from './AppDownloadPage';
export { default as BlogsList } from './Blogs/BlogsList';
export { default as CaseStudyList } from './CaseStudy/CaseStudyList';
